import { React } from "react";
import { NavLink } from "react-router-dom";
// import { SocialIcon } from "react-social-icons";

export default function navbar() {
    return (
        <header className="bg-gray-900">
            <div className="container mx-auto flex-wrap justify-between">
                <nav className="flex">
                    <NavLink
                        to="/"
                        exact
                        activeClassName="text-white"
                        className="inflex-flex items-center py-6 px-3 mr-4 text-red-100 hover:text-yellow-300 text-4xl font-bold cursive tracking-widest"
                    >
                        Infinity
                    </NavLink>
                    <NavLink
                        to="/post"
                        className="inline-flex items-center py-3 px-3 my-6 rounded text-red-200 hover:text-yellow-300"
                        activeClassName="text-red-100 bg-red-700"
                    >
                        Blog Posts
                    </NavLink>
                    <NavLink
                        to="/project"
                        className="inline-flex items-center py-3 px-3 my-6 rounded text-red-200 hover:text-yellow-300"
                        activeClassName="text-red-100 bg-red-700"
                    >
                        Projects
                    </NavLink>
                    <NavLink
                        to="/about"
                        className="inline-flex items-center py-3 px-3 my-6 rounded text-red-200 hover:text-yellow-300"
                        activeClassName="text-red-100 bg-red-700"
                    >
                        About Me
                    </NavLink>

                </nav>
                {/* <div className="inline-flex py-3 px-3 my-6">
                    <SocialIcon
                        url="https://twitter.com/anant_says"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                        url="https://github.com/anant-mhl"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                        url="https://linkedin.com/in/anant30"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                </div> */}
            </div>
        </header>
    )
}